import React, { useState, useEffect } from 'react';
import { callApi } from './api';

const ActivityLog = ({ ownerId, locationId, gateId, userId, limit = 25 }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLogs = async () => {
            setLoading(true);
            setError(null);
            try {
                const filters = { limit };
                if (ownerId) filters.ownerId = ownerId;
                if (locationId) filters.locationId = locationId;
                if (gateId) filters.gateId = gateId;
                if (userId) filters.userId = userId;

                const result = await callApi('listActivityLogsV2', filters);
                setLogs(result.logs);
            } catch (err) {
                console.error("Error fetching activity logs:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchLogs();
    }, [ownerId, locationId, gateId, userId, limit]);

    if (loading) {
        return <p>Laster logg...</p>;
    }

    if (error) {
        return <p style={{ color: 'red' }}>Kunne ikke laste logg: {error}</p>;
    }

    if (logs.length === 0) {
        return <p>Ingen logghendelser funnet.</p>;
    }

    const renderLogEntry = (log) => {
        const { timestamp, actor, action, target, status, details } = log;

        // Don't render logs that are clearly incomplete or internal noise
        if (!actor?.email || !action) {
            return null;
        }

        const time = timestamp ? new Date(timestamp._seconds * 1000).toLocaleString() : 'N/A';

        const formatDetails = () => {
            if (details?.error) return details.error;
            if (details?.changes) {
                return details.changes.map(c => `${c.field}: ${JSON.stringify(c.new)}`).join(', ');
            }
            if (details?.accessType) return `Type: ${details.accessType}`;
            if (details?.createdRole) return `Rolle: ${details.createdRole}`;
            return '-';
        };

        return (
            <tr key={log.id}>
                <td style={{ whiteSpace: 'nowrap' }}>{time}</td>
                <td>{actor.email}</td>
                <td>{action}</td>
                <td>{target?.name || target?.id || 'N/A'}</td>
                <td>{status || 'N/A'}</td>
                <td>{formatDetails()}</td>
            </tr>
        );
    };

    return (
        <div>
            <h3>Aktivitetslogg</h3>
            <table className="user-table">
                <thead>
                    <tr>
                        <th>Tidspunkt</th>
                        <th>Aktør</th>
                        <th>Handling</th>
                        <th>Mål</th>
                        <th>Status</th>
                        <th>Detaljer</th>
                    </tr>
                </thead>
                <tbody>
                    {logs.map(renderLogEntry)}
                </tbody>
            </table>
        </div>
    );
};

export default ActivityLog;
